module.exports = __webpack_public_path__ + "static/media/source-sans-pro-italic.e74f0128.woff";